import { Component } from '@angular/core';

import { ModalErrorArgs } from '../modals/modal-error-args';
import { BaseModal } from './modal-base';

@Component({
    selector: 'modal-error',
    templateUrl: './modal-error.component.html',
    styleUrls: ['./modal-error.component.scss']
})
export class ShowErrorModal extends BaseModal<ModalErrorArgs> {

    args: ModalErrorArgs;

    constructor() {
        super();
        this.args = new ModalErrorArgs('', '');
    }

    onActivate(args: ModalErrorArgs) {
        this.args = args;
    }

    onCloseClicked(e: MouseEvent) {
        e.preventDefault();
        this.closeDialog();
    }

    onClose() { }

}



// WEBPACK FOOTER //
// ./src/app/modals/modal-error.component.ts